import { WEBSOCKET_URL } from "configs/AppConfig"
import { PORTAL_CSRF_TOKEN } from "constants/StorageConstants"
import { io } from "socket.io-client"
import { useAuth } from "store/auth/AuthContext"
import { AuthType, AuthUser } from "store/auth/types"

/** Obtain token from local storage or session storage (legacy) */
export const getCsrfToken = (): string | undefined =>
  localStorage.getItem(PORTAL_CSRF_TOKEN) ?? sessionStorage.getItem(PORTAL_CSRF_TOKEN) ?? undefined

/** Create websocket connection */
export const createSocket = () =>
  io(WEBSOCKET_URL, {
    withCredentials: true,
    extraHeaders: {
      "X-CSRF-TOKEN": getCsrfToken() ?? "",
    },
  })

/** Custom hook to check if the user is authenticated */
export const useIsAuthenticated = (): boolean => {
  const { userExpires } = useAuth()
  return !!getCsrfToken() && userExpires !== undefined && userExpires >= new Date()
}

/**
 * Assuming we are authenticated, this returns the user details.
 * Throws if the user is not authenticated and attempts to redirect
 *
 * @returns AuthUser
 */
export const useAuthUser = (): AuthUser => {
  const { user, type } = useAuth()

  if (type === AuthType.Invalid || !user) {
    location.pathname = "/auth/login"
    throw new Error("useAuthUser can only be used in an authenticated context! Redirecting to login.")
  }

  return user
}
